import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { PROGRAMS, IMG } from "../../lib/content";
import { Reveal, EASE } from "../Reveal";

export const ProgramsSection = ({ full = false }) => (
  <section data-testid="programs" className="bg-dst-light text-dst-ink py-24 lg:py-36">
    <div className="container-dst">
      <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
        <Reveal>
          <span className="eyebrow text-dst-red">Programs</span>
          <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl text-dst-navy">
            Group Training,<br />Built To Compete
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-dst-ink/60 max-w-md text-lg">
            Group training is our specialty — the fastest, most competitive way to develop. Private one-on-ones are available too.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PROGRAMS.map((p, i) => {
          const big = !!p.featured;
          return (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: EASE }}
              data-testid={`program-${i}`}
              className={`group relative overflow-hidden transition-shadow duration-500 ${
                big
                  ? "md:col-span-2 lg:col-span-3 bg-dst-navy text-white shadow-[0_30px_80px_-20px_rgba(0,34,68,0.45)] ring-2 ring-dst-red"
                  : "bg-white shadow-[0_20px_60px_-20px_rgba(0,34,68,0.25)] hover:shadow-[0_30px_80px_-20px_rgba(200,16,46,0.35)]"
              }`}
            >
              <div className={big ? "grid lg:grid-cols-2" : ""}>
                <div className="relative overflow-hidden">
                  <img
                    src={IMG[p.img]}
                    alt={p.title}
                    loading="lazy"
                    className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${big ? "h-64 lg:h-full lg:min-h-[340px]" : "h-60"}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dst-navy/70 to-transparent" />
                  <span className={`absolute top-4 left-4 text-[11px] font-bold tracking-[0.15em] uppercase px-3 py-1.5 ${big ? "bg-dst-red text-white inline-flex items-center gap-1.5" : "bg-dst-red text-white"}`}>
                    {big && <Star size={12} className="fill-white" />}{p.tag}
                  </span>
                </div>
                <div className={big ? "p-8 lg:p-12 flex flex-col justify-center" : "p-7"}>
                  <h3 className={`font-oswald uppercase tracking-tight mb-3 ${big ? "text-4xl lg:text-5xl text-white" : "text-3xl text-dst-navy"}`}>{p.title}</h3>
                  <p className={`leading-relaxed ${big ? "text-white/70 text-lg" : "text-dst-ink/60"}`}>{full ? p.long : p.short}</p>
                </div>
              </div>
              {!big && <div className="h-1 w-0 bg-dst-red group-hover:w-full transition-all duration-500" />}
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
